/**
 * @file: 分销3.0  账号信息
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/05/09      1.0     First version
 * 2024/01/15      2.0     Second version
 * Copyright 2022, all rights reserved. Essa.cn
 * */

import React from "react";
import { Spin, Col, Row,  } from 'antd';
import {isEmpty,} from '@utils/utils';
import Lang from "@/components/Lang/Lang";
import FormFormat from '@components/FormFormat/FormFormat';
import dayjs from "dayjs";
import PropTypes from "prop-types";
import "./index.less";
export default class AddAndEditForm extends React.Component {
    static propTypes = {
        typeFrom: PropTypes.string,
    }
    static defaultProps = {
        typeFrom:"",// 订单提成 'orderCommission' ，注册提成：空， 不显示合同
        typeOption:"", // 操作类型:  edit 编辑状态
        userInfo:{},// 用户信息
        // userStatus:{},// 用户状态
    };
    constructor(props) {
        super(props);
        this.state = {
            // userStatus: props.userStatus,
            photoFileFormData:[
                {
                    name:'photoFile', // 头像
                    type:'UploadImage',
                    accept:'.jpg, .jpeg, .png, .gif',
                    flagLimitType:true,
                    // required: true,
                    styleUpload:"avatar",
                },
            ],
            commonFormData:[
                {
                    name:'telCode',  // 姓名
                    required: true,
                    hidden:true
                },
                {
                    name:'mobile',
                    cnTitle:'手机（登录名）',
                    cnTitleId:'ShouJiDengLuMing',
                    cnPlaceholder:'请输入登录名字',
                    cnPlaceholderId:'QingShuRuDengLuMingZi',
                    required: true,
                    type:'AreaPhone',
                    setCopyValue:'password',
                },
                props.typeOption=="edit"? null:{
                    name:'password',
                    cnTitle:'初始密码',
                    cnTitleId:'ChuShiMiMa',
                    cnPlaceholder:'等同手机号码',
                    cnPlaceholderId:'DengTongShouJiHaoMa',
                    required: true,
                    disabled:true,
                },
                {
                    name:'name',
                    cnTitle:'姓名',
                    cnTitleId:'XingMing',
                    cnPlaceholder:'请填写姓名',
                    cnPlaceholderId:'QingTianXieXingMing',
                    required: true,
                    maxLength:100,
                },
                // { // 无需显示，只要按入口 区分，编辑时不能修改
                //     name:'type',
                //     cnTitle:'分销类型',
                //     cnTitleId:'FenXiaoLeiXing',
                //     required: true,
                //     type:"Radio",
                //     radioClass:'fx_user_type',
                // },
                {
                    name:'sex',
                    cnTitle:'性别',
                    cnTitleId:'XingBie',
                    cnPlaceholder:'请选择性别',
                    cnPlaceholderId:'QingXuanZeXingBie',
                    required: true,
                    type:"RadioButton",
                    options:[
                        {
                            value:1,
                            cnTitleId:'Nan'
                        },
                        {
                            value:0,
                            cnTitleId:'Nu'},
                    ]
                },
                {
                    name:'region',
                    cnTitle:'国籍/地区',
                    cnTitleId:'GuoJiaDiQu2',
                    type:'Region',
                    required: true,
                },
                {
                    name:'email',
                    cnTitle:'电子邮件',
                    cnTitleId:'DianZiYouJian',
                    cnPlaceholder:'请填写电子邮件',
                    cnPlaceholderId:'QingTianXieDianZiYouJian',
                    type:'Email'
                },
                {
                    name:'idcardNo', // 证件号码
                    cnTitleId:'ZhengJianHaoMa',
                    cnPlaceholderId:'QingTianXieZhengJianHaoMao',
                    maxLength:100,
                    required: true,
                },
                {
                    name:'cardFile', //证件照片
                    cnTitleId:'ZhengJianZhaoPian',
                    cnPlaceholderId:'ZhengJianZhaoPian',
                    type:'UploadImage',
                    accept:'.jpg, .jpeg, .png, .gif',
                    // flagLimitType:true,
                    styleUpload:"RU_IDcard",
                    required: true,
                    // styleName:'width140',
                },
            ],
            bankFields:[
                {
                    name:'depositAccount', // 银行账号
                    cnTitleId:'YinHangZhangHao',
                    cnPlaceholderId:'YinHangZhangHao',
                    maxLength:100,
                },
                {
                    name:'depositBank', // 开户行
                    cnTitleId:'KaiHuHang',
                    cnPlaceholderId:'KaiHuHang',
                    maxLength:100,
                },
                {
                    name:'accountHolderName', // 开户名
                    cnTitleId:'KaiHuMing',
                    cnPlaceholderId:'KaiHuMing',
                    maxLength:100,
                },],
            contractFields:[
                {
                    name: 'id',  // 隐藏字段，必要
                    hidden:true
                },
                {
                    name:'code',  // 合同编号
                    cnTitleId:'HeTongBianHao',
                    required: true,
                    maxLength: 125,
                },
                {
                    name:'effectiveTime',
                    cnTitle:'有效期',
                    cnTitleId:'YouXiaoQi',
                    type:'DateRangePicker',
                    cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    errMsg: Lang({id:'QingShuRuYouXiaoQi',default:'请输入有效期'}),
                    required: true
                },
                {
                    name:'valueAddedTaxRate',  // 增值税率
                    cnTitleId:'ZengZhiShuiLv',
                    type:"Number",
                    addonAfter: "%",
                    numConfig:{
                        style:{width:"100%"},
                        precision:2,
                        min: 0.01,
                        max: 9999999999.99
                    },
                    required: true,
                },
                {
                    name:'companyName',  // 公司名称
                    cnTitleId:'GongSiMingCheng',
                    maxLength: 125,
                },
                {
                    name:'fileList',
                    cnTitle:'合同附件',
                    cnTitleId:'HeTongFuJian',
                    cnPlaceholderId:"QingXuanZe2",//请选择
                    type:'UploadFileIcon',
                    accept:'.pdf, .jpg, .jpeg, .png, .docx, .doc, .xlsx, .xls, .pdf',
                    fileSizeLimit: 10*1024*1024,
                    topTips: <div className={"black45 mb_4 font_12 topMinus"}>{Lang({id:'ShangChuanWenJianTiShi',default:'支持jpg/png/Word/Excel/PDF格式，单文件最大支持10M，最多上传5个文件'})}</div>,
                    required: true,
                    maxCount:5,
                    typeUpload:"display"
                },
            ]
        }
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 获取用户
     * */
    getInfo(){

    }
    /**
     * 处理表单
     * */
    reload(){
        this.setState({
            reloading: true
        },()=>{
            this.timer = setTimeout( () =>{
                this.setState({
                    reloading: false
                })
            }, 400);
        })
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    onRefFormBank = (ref) =>  this.onRefFormFormatBank = ref;
    onRefFormContact= (ref) =>  this.onRefFormFormatContact = ref;
    /**
     * 点击确认时 获取表单数据
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=157#4658
     ***/
    async handleOK(){
        const res = await this.onRefFormFormat.handleOK();
        if(res&&res.success){
            let postData = {...res.data};
            const bankData = await this.onRefFormFormatBank.handleOK();
            if(bankData.success&&bankData.data){
                let objBankAccount = {}; //银行卡信息
                if(bankData.data.depositAccount){
                    objBankAccount['depositAccount'] = bankData.data.depositAccount;
                }
                if(bankData.data.accountHolderName){
                    objBankAccount['accountHolderName'] = bankData.data.accountHolderName;
                }
                if(bankData.data.depositBank){
                    objBankAccount['depositBank'] = bankData.data.depositBank;
                }
                postData['bankAccount'] = objBankAccount;
            }
            if(this.onRefFormFormatContact){ // 如果有显示合同
                const pass = await this.onRefFormFormatContact.handleOK();
                if(pass.success&&pass.data){
                    // const dataContract = pass.data||{};
                    let objContract = {...pass.data}; //合同信息
                    if(objContract.effectiveTime){
                        objContract['effectiveStartTime'] = dayjs(objContract.effectiveTime[0]).startOf('day').valueOf();
                        objContract['effectiveEndTime'] = dayjs(objContract.effectiveTime[1]).endOf('day').valueOf();
                        delete objContract.effectiveTime;
                    }
                    postData['contract'] = objContract;
                }else {
                    return false
                }
            }
           return this.save(postData);
        }else return false
    }
    /*
    * 保存数据
    * */
    save(postData){
            if(postData.sex) postData["sex"] = Number(postData.sex);
            if(postData.cardFile&&postData.cardFile.length>0){
                const objCardFile = postData.cardFile[0];
                postData['cardFileId'] = objCardFile.fileId;
            }
            delete postData.cardFile;
            if(postData.photoFile&&postData.photoFile.length>0){
                const objChotoFile = postData.photoFile[0];
                postData['photoFileId'] = objChotoFile.fileId;
            }
            delete postData.photoFile;
            return {
                success: true,
                data: postData
            };
    }
    /*
    * 获取
    * */
    getOptions(photoFileFormData,commonFormData){
        if(this.props.renderSwitch){
            return [...photoFileFormData,this.props.renderSwitch(),...commonFormData];
        }else return [...photoFileFormData, ...commonFormData]
    }
    componentWillMount() {
        this.getInfo()
    }
    componentDidMount() {
        if(this.props.onRef)  this.props.onRef(this);
    };
    componentWillUnmount() {
      if(this.timer)clearTimeout(this.timer);
    }

    render() {
        const {typeFrom,userInfo={},loading,reloading=false,} = this.props;
        const { photoFileFormData,commonFormData,contractFields,bankFields } = this.state;
        return (<Spin spinning={loading||reloading}>
                {!reloading&&<div className={"distributionMain"}>
                    <Row gutter={40}>
                        <Col span={12}>
                            {/*   普通 表单 start */}
                            <FormFormat onRef={this.onRefForm}
                                        options={this.getOptions(photoFileFormData,commonFormData)}
                                        formItemLayout={null}
                                        initialValues={userInfo}
                                        formLayout = "vertical" />
                            {/*   普通 表单 end */}
                        </Col>
                        <Col span={12}>
                            {/*   合同信息 typeFrom：订单提成 'orderCommission' ，注册提成：空， 不显示合同 start */}
                            {typeFrom=="orderCommission"&&<div className={"rightBorderBox"}>
                                <div className={"font_16 flex-item-ver-center mb_12"}>
                                    <i className="ri-attachment-2 font_22 color-green"></i><span className={"ml_4 fw_700"}>{Lang({id:"HeTongXinXi", default:"合同信息"})}</span>
                                </div>
                                <FormFormat onRef={this.onRefFormContact}
                                            options={contractFields}
                                            formItemLayout={null}
                                            initialValues={userInfo.contract||{}}
                                            formLayout = "vertical" />
                            </div>}
                            {/*  合同信息 end */}
                            {/*   银行 表单 start */}
                            <div className={"rightBorderBox"}>
                                <div className={"font_16 flex-item-ver-center mb_4"}>
                                    <i className="ri-secure-payment-line color-blue font_24"></i><span className={"ml_4 fw_700"}> {Lang({id:"YinHangKaXinXi2", default:"银行卡信息"})}</span>
                                </div>
                                <div className={"color-err font_12 mb_12"}>{Lang({id:"FenXiaoShangDeYinHangZhangHuXinXiTiShi", default:"分销商的银行账户信息，用于后续的返利，务必请分销商提供正确的账户信息。"})}</div>
                                <FormFormat onRef={this.onRefFormBank}
                                            options={bankFields}
                                            formItemLayout={null}
                                            initialValues={userInfo.bankAccount||{}}
                                            formLayout = "vertical" />
                            </div>
                            {/*   银行 表单 end */}
                        </Col>
                    </Row>
                    {/*<Button type="primary" size={"large"} loading={loading}*/}
                            {/*onClick={()=>this.handleOK()}>{__getServerLanguage("BaoCun")}</Button>*/}
                </div>}
        </Spin>);
    }
}
